import { render, staticRenderFns } from "./BlockImages.vue?vue&type=template&id=3b36b764&"
import script from "./BlockImages.vue?vue&type=script&lang=js&"
export * from "./BlockImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports